<template>
<div>

    <div class="mcc-page-header">
        <div class="mu-d-flex ">
            <section class="mu-d-flex mu-flex-row">
                <h1>{{title}}</h1>
            </section>
        </div>
    </div>
    <div class="mcc-container-fluid card-padding">
        <div class="mcc-row" v-if="!fetchCall">
            <div class="mcc-col colSpinner">
                <div class="spinner-overlay">
                    <div class="spinner-background"></div>
                    <div class="spinner-flex">
                        <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                            <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        </svg>
                    </div>
                </div>

            </div>

        </div>
        <div class="mcc-row" v-if="fetchCall">
            <div class="mcc-col">
                <div class="mcc-card">
                    <div class="mcc-card__body">
                        <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mu-mb-06" v-if="processList.length > 0" :value="searchText" @input="searchText = $event.target.value">
                            <div class="mfc-input-group mfc-input-group--leading-icon">
                                <mcc-icon class="mfc-input-group__icon mu-pt-03" name="search" id="list-group-icon" aria-hidden="true"></mcc-icon>
                                <input type="search" id="searchProcess" name="searchInput" placeholder="Type to search...">
                            </div>
                        </div>

                       
                        <div class="mcc-intrinsic-grid" style="--mds-intrinsic-grid-repeat-count: auto-fill; --mds-intrinsic-grid-min: 24ch; --mds-intrinsic-grid-gap: 1rem;">
                                <div v-for="(proc, index) in filteredProcessList" :key="index" class="parentTile">
                                    <div type="button" class="mcc-tile mu-m-00 mu-p-00 mu-w-100">
                                        <mcc-icon :icon-set="proc.iconSet" :name="proc.processLogo" class="mcc-icon--secondary">
                                        </mcc-icon>
                                        <span class="text-center">{{proc.name}}</span>

                                    </div>
                                    <div role="group" aria-label="Start process" class="mcc-button-group tileActionButtons " :key="getKey()">
                                        <button class="mcc-button mcc-button--primary mcc-button--block mcc-button--sm" @click="redirectToViewProcess(proc)">
                                            <span class="mcc-button__label">Start Process</span>
                                        </button>

                                        <details class="mcc-dropdown">
                                            <summary class="mcc-button mcc-button--sm mcc-button--icon-only mcc-button--outline" aria-haspopup="true">
                                                <span class="[ mcc-button__label ] [ mu-visually-hidden ]">Dropdown</span>
                                                <mcc-icon class="mu-ml-00 mcc-icon" name="expand_arrow" aria-hidden="true"><svg width="24" height="24">
                                                        <use href="#mosaicjs_icon_fluency-outline_expand_arrow"></use>
                                                    </svg></mcc-icon>
                                            </summary>
                                            <ul class="mcc-dropdown__menu">
                                                <li>
                                                    <button type="button" @click="openShareDialog($event, proc)">
                                                        <div>Share</div>
                                                    </button>
                                                </li>
                                            </ul>
                                        </details>
                                    </div>
                                </div>
                        </div>

                    </div>

                </div>

            </div>

        </div>
        <div class="mcc-dialog-overlay">

            <dialog class="mcc-dialog mcc-dialog--info mcc-dialog--xs" ref="sharedialog" id="share-dialog">
                <section>
                    <div class="mcc-dialog__header">
                        <h2 class="h4">Share process start URL</h2>
                        <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="dialogCloseEvent">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                    </div>
                    <div class="mcc-dialog__body">
                        <form novalidate>

                            <div class="">
                                <div class="mfc-input-wrapper mfc-form-input-container" title="Standalone URL">
                                    <label for="mds-vcN9LyCI">Standalone</label>
                                    <div class="mfc-input-group"  @click="copyToClipbord(activeProc.standaloneURL)">
                                        <input type="text" name="prompt-text-entry" readonly="" id="standalone" :value="activeProc.standaloneURL">
                                        <button  type="button" class="mcc-button mcc-button--soft-secondary">Copy</button>
                                    </div>
                                </div>
                            </div>
                            <div class="mt-1">
                                <div class="mfc-input-wrapper mfc-form-input-container" title="Integrated URL" >
                                    <label for="mds-pQoFsS71">Integrated</label>
                                    <div class="mfc-input-group" @click="copyToClipbord(activeProc.integratedURL)">
                                        <input type="text" name="prompt-text-entry1" readonly="" id="integrated" :value="activeProc.integratedURL">
                                        <button  type="button" class="mcc-button mcc-button--soft-secondary">Copy</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="mcc-dialog__footer">

                        <div class="mcc-button-group mcc-button-group--spaced">

                            <button type="button" class="mcc-button mcc-button--info" @click="dialogCloseEvent">Close</button>
                        </div>
                    </div>
                </section>
            </dialog>
        </div>

    </div>
</div>
</template>

<script>
import MyProcessListAPI from "../../services/MyProcessListAPI";
import ApplicationTour from "../../ApplicationTour";
import Utils from "@/script_utils";

import {
    EventBus
} from '../../services/event-bus';

export default {
    name: "DeployedProcesses",
    data() {
        return {
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            processList: [],
            categoryName: '',
            fetchCall: false,
            activeProc: {
                process: null,
                standaloneURL: "",
                integratedURL: "",
            },
            searchText: ""
        };
    },
    computed: {
        filteredProcessList: function () {
            if (this.processList.length > 0 && this.searchText != undefined) {
                return this.processList.filter(process => {
                    return process.name.toLowerCase().includes(this.searchText.toLowerCase())
                })
            } else {
                return this.processList;
            }
        }
    },
    created() {
        this.title = this.$route.params.categoryName;
        this.categoryName = this.$route.params.categoryName;
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);

        var self = this;
        MyProcessListAPI.getDeployedProcesses(this.categoryName).then(result => {
            self.processList = result;
            for (let i = 0; i < self.processList.length; i++) {
                if (self.processList[i].processLogo != null && self.processList[i].processLogo.indexOf(':') != -1) {
                    let procLogo = self.processList[i].processLogo.split(':');
                    self.processList[i].processLogo = procLogo[0];
                    self.processList[i].iconSet = (procLogo.length > 1 && procLogo[1] != '') ? 'fluency-color' : ''
                } else {
                    self.processList[i].processLogo = 'process'
                    self.processList[i].iconSet = ''
                }
            }
            EventBus.$emit("update-pageTitle", self.categoryName);
        }).finally(() => {
            self.fetchCall = true;
            if (!Utils.isIEBrowser()) {
                var menuOnTop = this.$store.getters.getThemeData.menuOnTop;
                if (menuOnTop == null || menuOnTop == false) {
                    ApplicationTour.ShowTour();
                } else {
                    ApplicationTour.ShowTourForMenuOnTop();
                }
            }
        });
    },
    methods: {
        getKey() {
            return Utils.generateId();
        },
        openShareDialog(e, obj) {
            this.activeProc.process = obj;
            this.dialogOpenEvent();
            $('#share-dialog')[0].show();
        },
        dialogOpenEvent() {
            let processURL = this.CONTEXT_PATH + "/processes/viewprocess/" + this.activeProc.process.key;
            var location = window.location.origin + processURL;
            this.activeProc.integratedURL = location;

            location = window.location.origin + this.CONTEXT_PATH +
                "/standalone/external/processes/viewprocess/" + this.activeProc.process.key + "." + Buffer.from(this.activeProc.process.tenantId).toString('base64');
            this.activeProc.standaloneURL = location;
        },
        dialogCloseEvent(e) {
            this.activeProc.standaloneURL = "";
            this.activeProc.integratedURL = "";
            $('#share-dialog')[0].close();
        },
        copyToClipbord(text) {
            navigator.clipboard.writeText(text)
            EventBus.$emit("success-notification", {
                msg: "URL copied to clipboard"
            });
        },
        redirectToViewProcess(proc) {
            this.$router.push(
                this.CONTEXT_PATH +
                "/processes/viewprocess/" +
                proc.key
            );
        }
    }
};
</script>

<style scoped>
.parentTile {
    flex-direction: column;
    align-items: center;
    padding: 0.5rem;
    border: 1px solid #ccc;
    border-radius: 5px;
    max-width: 250px;
}

.mcc-tile {
    --mds-tile-border-color: none;
}

.mcc-button__dropdown-caret {
    margin-right: 0 !important;
}

.tileActionButtons {
    margin-left: 12px !important;
    width: 90% !important;
}

.mcc-tile span{
    white-space: initial !important;
}
</style><style scoped>
@import "/formdesigner/css/shepherd-theme-dark.css";
</style>
